import React from 'react';
import ModalTemplate from '../../../component/modal/ModalTemplate';

const CHANNEL_LABEL = {
    recv: '마케팅 정보',
    recvMms: '이벤트 및 혜택 SMS',
    recvMail: '이벤트 및 혜택 E-Mail',
    recvKakao: '이벤트 및 혜택 카카오톡',
};

/** 회원가입 화면에서 마케팅 수신동의 체크박스를 토글할 때, 사용자가 인지할 수 있게 띄우는 안내 모달 */
const MarketingConsentToggleModal = ({ isOpen, onRequestClose, channel, agreed }) => (
    <ModalTemplate open={isOpen} handleClose={onRequestClose} modalTitle="마케팅 수신 동의" className="react-modal">
        <div className="modal-body text-center py-4">
            <p className="mb-0">
                {CHANNEL_LABEL[channel] || '마케팅 정보'} 수신에 {agreed ? '동의하셨습니다.' : '동의를 해제하셨습니다.'}
            </p>
        </div>
        <div className="modal-footer">
            <button className="btn btn-primary w-100" onClick={onRequestClose}>확인</button>
        </div>
    </ModalTemplate>
);

export default MarketingConsentToggleModal;
